import Modal from "../modal/Modal";
import { MachineFormAdd } from "../../containers/machines";
import { Button } from "../buttons";
import { BUTTON_ADD_MACHINE_UPDATE } from "../../constants/buttons";

function MachineAddModal({
  openModal,
  setOpenModal,
  settings, 
  groupsList,
  groupsChildren,
  addData,
  setAddData,
  submitHandler,
  errors,
  children,
}) {
  return (
    <Modal
      dismissible
      size="2xl"
      show={openModal}
      onClose={() => setOpenModal(false)}
    >
      <Modal.Header>新しい設備を追加します</Modal.Header>
      <Modal.Body>
        {children}
        <MachineFormAdd
          settings={settings}
          groupsList={groupsList}
          groupsChildren={groupsChildren}
          addData={addData}
          setAddData={setAddData}
          errors={errors}
        />
      </Modal.Body>
      <Modal.Footer className="space-x-[32px]">
        <div className="w-1/2">
          <Button
            color="light"
            className="w-full"
            onClick={() => setOpenModal(false)}
          >
            閉じる
          </Button>
        </div>
        <div className="w-1/2">
          <Button
            id={BUTTON_ADD_MACHINE_UPDATE}
            color="primary"
            className="w-full"
            onClick={submitHandler}
          >
            新規追加
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default MachineAddModal;
